import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "InventoryLog";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row">
            <div className="col-xs-6 col-sm-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6">
            <BranchSelectAutoCompleteInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    label={LOOKUP.report.common.branch + "*"}
                                />
            </div> {/* .col */}
        </div>
        <div className="row">
            <div className="col-xs-12 col-sm-3">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    defaultValue="2"
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-3">
                <SelectInput
                    name={componentName + "SelectedCategory"}
                    fullWidth={true}
                    label={"Category"}
                    floatingLabelText={"Category"}
                    hintText={"Category"}
                    defaultValue={"0"}
                    options={(() => {
                        const categoryOptions = props.categoryOptions && props.categoryOptions.length > 0 ? props.categoryOptions : [];
                        let filteredCategories = [];
                        if (props.isCannabis == 0) {
                            filteredCategories = categoryOptions.filter(x => !x.isCannabis);
                        } else if (props.isCannabis == 1) {
                            filteredCategories = categoryOptions.filter(x => x.isCannabis);
                        } else {
                            filteredCategories =categoryOptions;
                        }
                        const allOption = [{ text: "All", value: "0" }];
                        const nonAllCategories = filteredCategories.filter(x => x.value !== "0");
                        return allOption.concat(nonAllCategories);
                    })()}

                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6">
                <AutoCompleteInput
                    name={`${componentName}ProductId`}
                    label="Search an existing product"
                    hintText="Product"
                    className={"AutoCompleteInput-searchbar"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
